import { render, staticRenderFns } from "./CustomSelectComponent.vue?vue&type=template&id=5758e96e&scoped=true&"
import script from "./CustomSelectComponent.vue?vue&type=script&lang=js&"
export * from "./CustomSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectComponent.vue?vue&type=style&index=0&id=5758e96e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5758e96e",
  null
  
)

export default component.exports